export const KNOWN_GET_READY_TASK_KEYS = [
	"complete_profile",
	"insurance",
	"schedule_appointment",
	"book_appointment",
	"upload_documents",
	"sign_consent",
	"fill_health_questionnaire",
] as const;

export type GetReadyTaskKey = (typeof KNOWN_GET_READY_TASK_KEYS)[number];

export function isGetReadyTaskKey(value: string): value is GetReadyTaskKey {
	return (KNOWN_GET_READY_TASK_KEYS as readonly string[]).includes(value);
}

export interface GetReadyTaskCatalogEntry {
	taskKey: GetReadyTaskKey;
	/** i18n key within the `getReady` namespace */
	titleKey: string;
	/** i18n key within the `getReady` namespace */
	subtextKey: string;
	/** Icon name compatible with the Journey TaskCard ACTION_ICON mapping */
	iconName: string;
}

export const GET_READY_TASK_CATEGORIES = [
	"admin",
	"test_appt",
	"cycle",
	"meds",
] as const;

export type GetReadyTaskCategory = (typeof GET_READY_TASK_CATEGORIES)[number];

export function isGetReadyTaskCategory(
	value: unknown,
): value is GetReadyTaskCategory {
	return (GET_READY_TASK_CATEGORIES as readonly unknown[]).includes(value);
}

export interface GetReadyTaskProgressMeta {
	current: number;
	total: number;
	unit: string;
	percent: number;
}

export interface GetReadyRequiredDocument {
	key: string;
	label?: string;
	status: "pending" | "uploaded" | "completed";
}

export interface GetReadyTaskRenderModel {
	/** Durable backend task instance id used for task actions. */
	id: string;
	/** Catalog tasks use frontend copy; custom tasks use backend-owned copy. */
	kind: "catalog" | "custom";
	/**
	 * Raw key from the backend. This is a string (not narrowed to GetReadyTaskKey)
	 * because the API is untrusted input and can drift.
	 */
	taskKey: string;
	status: "pending" | "in_progress" | "completed";
	/** Stable ordering within its step group */
	order: number;
	/** Display-ready deadline string (meta.deadlineText or meta.deadlineLabel) */
	deadlineText?: string;
	title: string;
	subtext?: string;
	iconName: string;
	/** Backend-provided category; drives card border and progress fill colors */
	category?: GetReadyTaskCategory;
	/** Progress metadata for the expanded card progress block */
	progress?: GetReadyTaskProgressMeta;
	/** Required documents list for the expanded card docs block */
	requiredDocuments?: GetReadyRequiredDocument[];
}
